import { IDictionaryDTO } from "interfaces";
import { mockData } from "services/mock-data";

export const useRinexStartHours = (): IDictionaryDTO[] => {
  return mockData.rinexStartHours;
};
